export enum UserRole {
    SUPERADMIN = 1,
    ADMIN = 2,
    USER = 3,
    VIEWONLY = 4
}
export enum TypeTransaction {
    DEPOSIT = 0,
    WITHDRAW = 1
}
export enum ModeUI {
    LIGHT = "light",
    DARK = "dark",
    AUTO = "auto"
}
export enum TransactionStatus {
    WITHOUT_RECEIVE = 0,
    FINISH = 1,
    CANCLED = 2
}
export enum TimeModeFilterTransaction {
    MONTH = "This Month",
    LAST_MONTH = "Last Month",
    CUSTOM = "custom"
}
export enum EnumStatus {
    INAVTIVE = 0,
    ACTIVE = 1
}
export enum EnumGender {
    MALE = 1,
    FEMALE = 2
}

export enum EnumTypeTa {
    SC = 1,
    SPR = 2,
    NORMAL = 3,
    OTHER = 4
}